import styled from 'styled-components';
import KitchenetteSvg from '../../assets/amenities/kitchenette.svg';

const KitchenetteIcon = styled(KitchenetteSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default KitchenetteIcon;
